import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { usePhonelineSetup } from './usePhonelineSetup'

type BouyguesPhonelineSetup =
  ApiSpecs['/mobile-plan/api/v1/customer-account/bouygues-telecom/phone-line-setup']['GET']['response']

export function useBouyguesPhonelineSetup() {
  const { user } = useUserStore()
  const $httpFetch = useHttpFetch()

  return usePhonelineSetup<BouyguesPhonelineSetup>(
    `phoneline-setup-BOUYGUES_TELECOM-${user.value?.bmUserId}`,
    () =>
      $httpFetch(
        '/mobile-plan/api/v1/customer-account/bouygues-telecom/phone-line-setup',
      ),
  )
}
